<script>
  import { createEventDispatcher } from "svelte";
  import { _ } from "svelte-i18n";
  import { declination } from "../../../../../helpers";
  
  const dispatch = createEventDispatcher();

  export let comment;
</script>

<div 
  class="comment-get-child-action"
  class:active="{comment.active}"
  on:click="{() => dispatch('get-children')}"
>
  <i class="icon-arrow_bottom" />
  <span>
    { declination(comment.childrens_count, $_('oneAnswer'), $_('twoAnswer'), $_('fiveAnswers')) }
  </span> 
</div>

<style>
  .comment-get-child-action {
    font-size: 16px;
    padding-bottom: 16px;
    line-height: 23px;
    color: #2B50ED;
    margin-left: 35px;
    cursor: pointer;
  }

  .active {
    display: none;
  }
</style>